import { render, staticRenderFns } from "./NavigationDrawer2.vue?vue&type=template&id=5c1b1300&scoped=true"
import script from "./NavigationDrawer2.vue?vue&type=script&lang=js"
export * from "./NavigationDrawer2.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawer2.vue?vue&type=style&index=0&id=5c1b1300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b1300",
  null
  
)

export default component.exports